export default {
  title: 'Contract Info',
  contractName: 'Name',
  contractStatus: 'Status',
  contractNum: 'Number',
  contractType: 'Type',
  contractTypePlaceholder: 'Please enter type',
  contractPayType: 'Pay Type',
  contractAmount: 'Amount',
  contractAmountPlaceholder: 'Please enter amount',
  contractSignDate: 'Sign Date',
  contractEffectiveDate: 'Effective Date',
  contractEndDate: 'End Date',
  company: 'Company',
  employee: 'Employee',
  pay: 'pay',
  receive: 'received',
  upload: 'upload file',
  uploadFile: 'upload contract file',
  uploadTips: 'Please upload a PDF file, with a size limit of 60MB.',
  otherInfo: 'Other Info',
  remark: 'Remark',
  remarkPlaceholder: 'please enter remark',
  notaryPublic: 'Notary Public',
  confirm: 'confirm',
  cancel: 'cancel',
};
